/* eslint-disable fp/no-mutation */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export type DismissedSuggestionsReduxState = {
  dismissedSuggestions: string[];
};

const initialState: DismissedSuggestionsReduxState = {
  dismissedSuggestions: [],
};

const dismissedSuggestionsSlice = createSlice({
  initialState,
  name: 'dismissedSuggestions',
  reducers: {
    clearDismissedSuggestions: (state) => {
      state.dismissedSuggestions = [];
    },
    dismissSuggestion: (state, { payload }: PayloadAction<string>) => {
      if (!state.dismissedSuggestions.includes(payload)) {
        state.dismissedSuggestions = [...state.dismissedSuggestions, payload];
      }
    },
    undismissSuggestion: (state, { payload }: PayloadAction<string>) => {
      state.dismissedSuggestions = state.dismissedSuggestions.filter((suggestion) => suggestion !== payload);
    },
  },
});

export const { reducer: dismissedSuggestionsReducer } = dismissedSuggestionsSlice;
export const { clearDismissedSuggestions, dismissSuggestion, undismissSuggestion } = dismissedSuggestionsSlice.actions;
